import Vue from 'vue'

const POST = {
	BY_ID: (id, filter) => {
		return Vue.$api.get('/posts/' + id, { params: { filter: filter } })
	},
	LIST: filter => {
		return Vue.$api.get('/posts', { params: { filter: filter } })
	},
	COUNT: where => {
		return Vue.$api.get('/posts/count', { params: where })
	},
	UPDATE: post => {
		return Vue.$api.patch('/posts/' + post.id, post)
	},
	RANK: post => {
		return Vue.$api.get('/posts/' + post.detailId + '/rank/' + post.code)
	},
	EVOLUTION: filter => {
		return Vue.$api.get('/posts/history', { params: { filter: filter } })
	},
	TOP: filter => {
		return Vue.$api.get('/posts/top', { params: filter })
	},
	POST_TYPE: filter => {
		return Vue.$api.get('/posts/post-type', { params: filter })
	},
}

export default POST
